import axios from "axios";
export default {
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    async loadResetUserDetail(){
      return await axios.get(`/superadmin/reset-users/1`)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async updateResetUser( _, formData){
      return await axios.put(`/superadmin/reset-users/1`, formData)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
  },
};
